import ControlFactory from '@/Factories/ControlFactory';
import AssociationLink from '@/Controls/AssociationLink';
import AssociationLinkViewModel from '@/ViewModels/Controls/AssociationLinkViewModel';
import AssociationLinkViewModelT from '@/ViewModels/Controls/AssociationLinkViewModel';
import LinkViewModelT from '@/ViewModels/Controls/LinkViewModel';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import ComponentManager from '@/Management/ComponentManager';
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import NavigationHelper from '@/Management/NavigationHelper';
export default class AssociationLinkFactory extends ControlFactory {
    /** Overrides */
    public control: AssociationLink;
    /** Overrides */
    public viewModel: AssociationLinkViewModel;
    public defaultIterator: any;
    public iterator: any;
    public isFocusable: any;
    private AssociationLinkViewModel: any;
    private AssociationLink: any;
    protected LinkViewModel: any;
    protected LabelViewModel: any;
    protected jQueryControl: JQuery;
    constructor(params: any) {
        super(params);
        this.jQueryControl = null;
        this.AssociationLinkViewModel = ComponentManager.getViewModel<typeof AssociationLinkViewModelT>('AssociationLinkViewModel');
        this.AssociationLink = ComponentManager.getControl('AssociationLink');
        this.LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModelT>('LinkViewModel');
        this.LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
        this.defaultIterator = this.context.defaultIterators[this.detailViewItem.name];
        this.iterator = null;
        this.isFocusable = false;
        this.registerForMessageId('RefreshAssociationsMessage', () => {
            this.viewModel.values.evaluate();
        });
    }
    /** Overrides */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        let getIterator = () => {
            return RADEnvironmentProxy.getInstance().createIteratorForAssoziation({
                pdTypeName: this.context.genericObject.pdTypeName,
                pdo_id: this.context.genericObject.pdoId,
                assoziationName: this.detailViewItem.name,
                properties: ['ObjectIdentValue'],
                retrieveExtentCount: true,
                itOperator: {
                    includeAllPrincipals: this.detailViewItem.listView.includeAllPrincipals,
                    includeBasePrincipals: this.detailViewItem.listView.includeBasePrincipals,
                    includeSubPrincipals: this.detailViewItem.listView.includeSubPrincipals,
                    memoryOptimizationEnabled: true,
                    onlySubPrincipals: null,
                    historizationDates: null,
                    isGridIterator: null,
                    principalFilter: null,
                    searchObjectPositionRequest: null,
                    visibleDeletedObjects: null,
                    hideConnectedElementsRequest: null
                },
                filter: '',
                orderby: ''
            });
        };
        this.viewModel = (() => {
            this.isBusy(true);
            let convertGenericArrayIntoLinks = (arrayOfGeneric) => {
                let createLink = (generic, idx, principalFilterMode) => {
                    return new this.LinkViewModel({
                        parentLocator: this.locator,
                        locator: this.detailViewItem.name + '.' + String(idx),
                        onClick: (openInNewWindow) => {
                            if (openInNewWindow)
                                NavigationHelper.navigateAssociation(this.detailViewItem.listView.typeName, generic[0], {
                                    contextSource: this.context.isSummaryViewMode() ? 'SV' : 'DV',
                                    contextTypeName: this.context.getPdTypeName(),
                                    contextObject: this.context.genericObject.pdoId,
                                    contextRelation: this.detailViewItem.name,
                                    principalFilterMode: principalFilterMode
                                }, openInNewWindow);
                            else
                                this.context.createContext(this, this.detailViewItem.listView, generic[0], undefined, principalFilterMode);
                        },
                        isFocusable: this.isFocusable,
                        label: new this.LabelViewModel({
                            caption: generic[1],
                            parentLocator: this.locator,
                            locator: this.detailViewItem.name + '.' + String(idx) + '.label'
                        }),
                        isEnabled: this.defineComputed(() => {
                            if (!this.detailViewItem.listView.showButtonEdit && !this.detailViewItem.listView.showButtonSelect) return false;
                            if (generic[0] == this.detailViewItem.disableNavigation) return false;
                            return true;
                        }),
                        isToolBarLink: false // warum stand hier mal true?
                    });
                }
                let createEmptyLink = () => {
                    return new this.LinkViewModel({
                        label: new this.LabelViewModel({
                            caption: '-'
                        }),
                        isEnabled: false
                    });
                }
                let result = [];
                let principalFilterMode = undefined;
                if (this.detailViewItem && this.detailViewItem.listView) {
                    if (this.detailViewItem.listView.includeAllPrincipals) {
                        principalFilterMode = 'PRINCIPAL_SELECTOR_ALL';
                    }
                    else if (this.detailViewItem.listView.includeBasePrincipals) {
                        principalFilterMode = 'PRINCIPAL_SELECTOR_WITH_BASE';
                    }
                    else if (this.detailViewItem.listView.includeSubPrincipals) {
                        principalFilterMode = 'PRINCIPAL_SELECTOR_CURRENT_AND_SUB';
                    }
                }
                if (arrayOfGeneric.length > 0) {
                    for (let i = 0; i < arrayOfGeneric.length; i++) {
                        result.push(createLink(arrayOfGeneric[i], i, principalFilterMode));
                    }
                } else {
                    result.push(createEmptyLink());
                }
                return result;
            }
            let onIteratorLoaded = (iterator) => {
                this.iterator = iterator;
                if (this.iterator.extentCount > 0) {
                    return RADEnvironmentProxy.getInstance().getExtentWithPDOIDAsFirstColumn({
                        iteratorID: this.iterator.id,
                        start: 0,
                        end: this.iterator.extentCount - 1
                    }).then(convertGenericArrayIntoLinks);
                } else {
                    return [
                        new this.LabelViewModel({
                            caption: '-'
                        })
                    ];
                }
            }
            return new this.AssociationLinkViewModel({
                factory: this,
                isRequired: this.isRequired,
                isEnabled: this.isEnabled,
                invalidationText: this.invalidationText,
                isValid: this.isValid,
                isBusy: this.isBusy,
                parentLocator: this.locator,
                locator: this.detailViewItem.name,
                tooltip: new this.LabelViewModel({
                    ergName: this.detailViewItem.tooltip
                }),
                values: this.defineAsyncComputed((): any => {
                    if (!this.detailViewItem.isToManyAssoziation) {
                        let name = this.detailViewItem.name;
                        let go = this.context.genericObject;
                        if (go.values[name + '.PDO_ID'] != undefined && go.values[name + '.ObjectIdentValue']) {
                            // In diesem Zweig (this.defaultIterator == null) wissen wir, dass wir als Label auf jeden Fall ObjectIdentValue anzeigen w�rden.
                            // Zudem liegen passende Properties bereits im GenericObject!
                            // Statt zu iterieren, holen wir uns die Daten direkt.
                            let pdoId = go.getValue(name + '.PDO_ID');
                            let ident = go.getValue(name + '.ObjectIdentValue');
                            let items = [];
                            if (pdoId != null && ident != null) {
                                items.push([pdoId, ident]);
                            }
                            let def = $.Deferred();
                            def.resolve(convertGenericArrayIntoLinks(items));
                            this.isBusy(false);
                            return def.promise();
                        }
                    }
                    this.deleteIterators([this.iterator]);
                    $.when(getIterator()).then((iterator) => {
                        if (this.isDisposed !== false)
                            return undefined;

                        this.isBusy(false);
                        return onIteratorLoaded(iterator);
                    });
                }, [])
            });

        })();
        this.control = (() => {
            return new this.AssociationLink(this.viewModel);
        })();
        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;
        this.registerObservableValidation(this.viewModel.values);
        return this.jQueryControl;
    }
    public notifyDetailViewClosed(topdTypeName?: any, toPDOID?: any): void {
        this.viewModel.values.evaluate();
    }
    public deleteIterators(iterators: any): any {
        if (this.isDisposed || iterators == null) {
            return;
        }
        iterators = iterators.filter((it) => { return it != null; });
        if (iterators != null && iterators.length > 0) {
            RADEnvironmentProxy.getInstance().deleteIterators({
                iteratorIDs: iterators.map((it) => { return parseInt(it.id); })
            });
        }
    }
    protected disposeInternal(): void {
        this.deleteIterators([this.defaultIterator, this.iterator]);
        this.unregisterForMessageId('RefreshAssociationsMessage');
        super.disposeInternal();
    }
}

ComponentManager.setFactory('AssociationLink', AssociationLinkFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setFactory('AssoziationLink', AssociationLinkFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');